import React, { useState, useContext } from "react";
import { Outlet } from "react-router-dom";
import { Heading, useToast } from "@chakra-ui/react";
import ForgotPasswordStep1 from "./ForgotPasswordStep1";
import ForgotPasswordStep2 from "./ForgotPasswordStep2";
import { AccountContext } from "../../context/AccountContext";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [errorText, setErrorText] = useState("");
  const { forgotPassword, confirmPassword } = useContext(AccountContext);

  const forgotPasswordHandler = (event) => {
    event.preventDefault();
    setIsLoading(true);
    setEmail(event.target.email.value);
    forgotPassword(email).then(
      (response) => {
        console.log(response);
        setStep(2);
        setIsLoading(false);
      },
      (error) => {
        console.log(error);
        setIsLoading(false);
      }
    );
  };

  const confirmPasswordHandler = (event) => {
    event.preventDefault();
    if (errorText) {
      setErrorText("");
    }
    setIsLoading(true);
    const verificationCode = event.target.verificationCode.value;
    const newPassword = event.target.newPassword.value;
    confirmPassword(email, verificationCode, newPassword).then(
      (response) => {
        console.log(response);
        setIsLoading(false);
        toast({
          title: "Password Changed",
          description: "Please sign in with your new password",
          status: "success",
          duration: 5000,
          isClosable: true,
          variant: "left-accent",
          position: "top",
        });
        navigate("/");
      },
      (error) => {
        console.log(error);
        setIsLoading(false);
        setErrorText(error.message);
      }
    );
  };

  return (
    <div>
      <Outlet />
      <Heading mb={4}>Forgot your password?</Heading>
      {step === 1 ? (
        <ForgotPasswordStep1
          email={email}
          setEmail={setEmail}
          isLoading={isLoading}
          forgotPasswordHandler={forgotPasswordHandler}
        />
      ) : (
        <ForgotPasswordStep2
          errorText={errorText}
          isLoading={isLoading}
          confirmPasswordHandler={confirmPasswordHandler}
        />
      )}
    </div>
  );
};

export default ForgotPassword;
